import { render } from "./ItemUpload.vue?vue&type=template&id=00d47395&scoped=true"
import script from "./ItemUpload.vue?vue&type=script&lang=js"
export * from "./ItemUpload.vue?vue&type=script&lang=js"

import "./ItemUpload.vue?vue&type=style&index=0&id=00d47395&scoped=true&lang=css"

import exportComponent from "D:\\code\\miao-up-up-mobile-spa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d47395"]])

export default __exports__